
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.23 19.02A6.758 6.758 0 0012 21a6.758 6.758 0 006.75-6.75 7.548 7.548 0 00-1.143-3.755l-4.972-7.917a.78.78 0 00-1.27 0L6.37 10.534A7.488 7.488 0 005.25 14.25a6.759 6.759 0 001.98 4.77zm.434-7.728L12 4.386l4.314 6.868c.57.899.893 1.932.936 2.996a5.25 5.25 0 11-10.5 0c.04-1.049.355-2.07.914-2.958zM12 17.37c0 .343.289.62.624.549a3.95 3.95 0 003.045-3.045c.071-.335-.206-.624-.55-.624H14.8c-.311 0-.563.242-.658.539a2.474 2.474 0 01-1.603 1.603c-.297.095-.539.347-.539.658v.32z"}})])
          )
        }
      }
    